import { useCallback, useEffect, useState } from "react";
import { api, ITEM_TYPES } from "@/lib/api";

export function useStockItems() {
  const [items, setItems] = useState({ fg: [], sfg: [], carton: [], plastic: [], other: [] });
  const reload = useCallback(async () => {
    const res = await Promise.all(ITEM_TYPES.map((x) => api.get(`/masters/${x.kind}`)));
    setItems(Object.fromEntries(ITEM_TYPES.map((x, i) => [x.v, res[i].data])));
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const lookup = useCallback((type, id) => (items[type] || []).find((x) => x.id === id) || {}, [items]);
  return { items, reload, lookup };
}
